export default __webpack_public_path__ + "static/media/Abrar Ahmed.cf3e0ca9.jpeg";